import { XhrFactory } from '@angular/common';
import { HttpBackend, HttpClient, HttpHandler, HttpXhrBackend } from '@angular/common/http';
import { enableProdMode, Injectable, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ConfigurationApiService } from './app/core/services/http/configuration-api.service';
import { environment } from './environments/environment';

import { FeatureTogglesApiService } from './app/core/services/http/feature-toggles-api.service';
import { addTrackToPromisePrototype } from './app/modules/data/data-entry/shared/spinner/busy-tracking.service';

addTrackToPromisePrototype();
if (environment.production) {
    enableProdMode();
}

@Injectable()
export class BrowserXhr implements XhrFactory {
    build(): XMLHttpRequest {
        return new XMLHttpRequest();
    }
}

const injector = Injector.create({
    providers: [
        { provide: HttpClient, useClass: HttpClient, deps: [HttpHandler] },
        { provide: HttpHandler, useClass: HttpXhrBackend, deps: [XhrFactory] },
        { provide: HttpBackend, useClass: HttpXhrBackend, deps: [XhrFactory] },
        { provide: XhrFactory, useClass: BrowserXhr, deps: [] },
        { provide: ConfigurationApiService, deps: [HttpClient] },
        { provide: FeatureTogglesApiService, deps: [HttpClient] }
    ]
});

const configApiService = injector.get(ConfigurationApiService);
const featureToggleApiService = injector.get(FeatureTogglesApiService);

configApiService
    .getConfiguration()
    .then(() => featureToggleApiService.getFeatureToggles())
    .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
    .catch(err => console.error(err));
